var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/10a9468752fd36cc32d8198436af2920.js').default;export default
        Object.assign({}, scope_0 )
    